(function () {
    'use strict';

    angular
        .module('app')
        .factory('searchService', searchService);

    searchService.$inject = ['$http', 'gridDataService',
        '$localStorage', '$q', 'dataCardService',
        '$filter', 'columnFactory', 'enumFactory', 'breadCrumbService', 'loginService'];

    function searchService($http, gridDataService,
        $localStorage, $q, dataCardService,
        $filter, columnFactory, enumFactory, breadCrumbService, loginService) {
        var service = {};
        loginService.log("SEARCH SERVICE LOADING");
        service.searchCriteria = [];
        service.processing = false;

        service.dateFormat = -1; // DATE_FMT.UNKNOWN
        service.dateOnlyFormatter = "";
        service.dateTimeFormatter = "";

        service.close = function () {
            service.searchCriteria = [];

            service.dateFormat = -1; // DATE_FMT.UNKNOWN
            service.dateOnlyFormatter = "";
            service.dateTimeFormatter = "";
        }

        //public ApiTypes.DATE_FMT dateFormat;
        //public string dateOnlyFormatter;
        //public string dateTimeFormatter;
        service.getDateFormat = function() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/AdminOptions/DateFormat').then(function (response) {
                service.dateFormat = response.data.dateFormat;
                service.dateOnlyFormatter = response.data.dateOnlyFormatter;
                service.dateTimeFormatter = response.data.dateTimeFormatter;
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }
        //getDateFormat(); // DATEFMTWND

        //public enum DATE_FMT { UNKNOWN = -1, ADEPTSTD, YEAR_MONTH_DAY, ISO_UTC, ISO_LOCAL, DF_WINDOWS };
        //new Date(year, month, day, hours, minutes, seconds, milliseconds) 
        service.dateParse = function (localDate) {
            // breakhere
            var year = "";
            var month = "";
            var day = "";
            var date = null;
            if(service.dateFormat == 0) { // MM/DD/YYYY
                if (localDate.length == 10) {
                    year = localDate.substr(6, 4);
                    month = localDate.substr(0, 2);
                    day = localDate.substr(3, 2);
                }
                month = month - 1; // js month is 0 based
                date = new Date(year, month, day, 12, 0, 0, 0);
            }
            if (service.dateFormat == 1) { // YYYY/MM/DD
                if (localDate.length == 10) {
                    year = localDate.substr(0, 4);
                    month = localDate.substr(5, 2);
                    day = localDate.substr(8, 2);
                }
                month = month - 1; // js month is 0 based
                date = new Date(year, month, day, 12, 0, 0, 0);
            }
            if (service.dateFormat == 2 || service.dateFormat == 3) { // YYYY-MM-DD
                if (localDate.length == 10) {
                    year = localDate.substr(0, 4);
                    month = localDate.substr(5, 2);
                    day = localDate.substr(8, 2);
                }
                month = month - 1; // js month is 0 based
                date = new Date(year, month, day, 12, 0, 0, 0);
            }
            if (service.dateFormat == 4) { // Failing over to YYYY-MM-DD
                if (localDate.length == 10) {
                    year = localDate.substr(0, 4);
                    month = localDate.substr(5, 2);
                    day = localDate.substr(8, 2);
                }
                month = month - 1; // js month is 0 based
                date = new Date(year, month, day, 12, 0, 0, 0);
            }
            return date;
        }

        service.dateToString = function (d) {
            // breakhere
            var str = $filter('date')(d, service.dateOnlyFormatter);
            return str;
        }


        //// DATEFMTWND - Convert all of the dates to placeholder UTC.
        //function formatLocalToUtc(record) {
        //    if (service.dateFormat != 4) // DATE_FMT.DF_WINDOWS
        //        return; 
        //    angular.forEach(service.searchCriteria, function (value, key, obj) {
        //        if (value.startDate != "")
        //            value.startDate = dataCardService.localDateStringToUtcString(value.startDate);
        //        if (value.endDate != "")
        //            value.endDate = dataCardService.localDateStringToUtcString(value.endDate);
        //    });
        //}

        //// DATEFMTWND - format date values to users local date/time format
        //function formatUtcToLocal(record) { // response
        //    if (service.dateFormat != 4) // DATE_FMT.DF_WINDOWS
        //        return;
        //    angular.forEach(service.searchCriteria, function (value, key, obj) {
        //        if (value.startDate != "")
        //            value.startDate = dataCardService.utcStringToLocalDateString(value.startDate);
        //        if (value.endDate != "")
        //            value.endDate = dataCardService.utcStringToLocalDateString(value.endDate);
        //    });
        //}

       
        //call to get data from the server
        service.getData = function (skip, take, totalRecords, sort, sortOrder, countOperation, resultType, columns) {
            if (service.searchCriteria.length == 0) {
                service.searchCriteria = $localStorage.userSettings["searchCriteria"];
            }
            else {
                $localStorage.userSettings["searchCriteria"] = service.searchCriteria;
            }

            var deferred = $q.defer();
            var canceller = $q.defer();

            var cancel = function (reason) {
                canceller.resolve(reason);
            }

            loginService.log("service.getData called.");
            loginService.log(service.searchCriteria[0].schemaID);

            // System searches are not saved as last search.
            var url = '../Synergis.WebApi/api/document/byfields/';
            if (service.searchCriteria && service.searchCriteria.length > 0 && service.searchCriteria[0].bSystem)
                url = '../Synergis.WebApi/api/document/ByFieldsSystem/';

            service.processing = true;

            //breadcrumb
            if (service.searchCriteria.length == 1 && service.searchCriteria[0].schemaID == "SCHEMA_S_LIBID") {
                breadCrumbService.category = loginService.resourceStrings["LIBRARY"];
                breadCrumbService.details = service.searchCriteria[0].name;
            }
            else {
                breadCrumbService.category = loginService.resourceStrings["SEARCH"];
                service.getCriteriaDisplay(service.searchCriteria).then(function (criteriaString) {
                    breadCrumbService.details = criteriaString;
                    breadCrumbService.node = null;
                });
            }
            

            //formatLocalToUtc(); // DATEFMTWND - Convert local to UTC placeholder.
            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            var request = $http({
                url: url,
                method: 'POST',
                timeout: canceller.promise,
                responseType: responseType,
                data: JSON.stringify({
                    SearchCriteria: service.searchCriteria,
                    UserId: "",
                    Sort: { SortField: sort, SortOrder: sortOrder },
                    ResultType: resultType,
                    Columns: columns,
                    //ViewContext: "",
                    CountOperation: countOperation,
                    AdeptDataTable: {
                        TableDefinition: null,
                        TableRecords: null,
                        RecordCount: totalRecords,
                        Skip: skip,
                        Take: take,
                    }
                }),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                //formatUtcToLocal(); // DATEFMTWND - restore
                service.processing = false;
                deferred.resolve(response);
            }, function (response) {
                //formatUtcToLocal(); // DATEFMTWND - restore
                service.processing = false;
                deferred.reject(response);
            });

            return {
                promise: deferred.promise,
                cancel: cancel
            }
        };

        service.getDocsByList = function (keys) {
            var deferred = $q.defer();
            var request = $http({
                url: '../Synergis.WebApi/api/document/bylist/',
                method: 'POST',
                data: JSON.stringify(keys),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.processing = false;
                deferred.resolve(response);
            }, function (response) {
                service.processing = false;
                deferred.reject(response);
            });

            return deferred.promise;
        }

        service.getDocsByListForWorkArea = function (keys, workAreaId) {
            var deferred = $q.defer();
            var url = '../Synergis.WebApi/api/document/bylist/' + workAreaId + "/";
            var request = $http({
                url: url,
                method: 'POST',
                data: JSON.stringify(keys),
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                service.processing = false;
                deferred.resolve(response);
            }, function (response) {
                service.processing = false;
                deferred.reject(response);
            });

            return deferred.promise;
        }

        service.getCount = function () {
            var deferred = $q.defer();
            service.getData(0, 0, 0, "SCHEMA_S_LONGNAME", 0, true).promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            });
            return deferred.promise;
        }


        service.parseOperations = function(value) {
            var operations = [];
            angular.forEach(value, function (item, key) {
                var schemaId = item.schemaID;

                //make sure the search operation is defined
                if (!item.searchOp) {
                    item.searchOp = "";
                }

                //find out if it's a date field
                var isDate = false;
                angular.forEach(dataCardService.tabs, function (item, key) {
                    angular.forEach(item.dates, function (item, key) {
                        if (item.dataCardControlDefinition.id == schemaId) {
                            isDate = true;
                        }
                    });
                });

                var isLogical = false;
                angular.forEach(dataCardService.tabs, function (item, key) {
                    angular.forEach(item.logical, function (item, key) {
                        if (item) {
                            if (item.dataCardControlDefinition.id == schemaId) {
                                isLogical = true;
                            }
                        }

                    });
                })

                var operation = "";
                var valueString = item.valueStr;

                var schema = $filter('filter')(columnFactory.availableColumns, { schemaID: item.schemaID });
                //extra check in case it doesn't find it.
                var schemaName = "";
                if (schema.length > 0) {
                    schemaName = schema[0].displayName;
                }
                else if (schemaId == "__SEARCH_MEMO__") {
                    schemaName = "Memo"
                }
                else if (schemaId == "__SEARCH_ALL_FIELDS__") {
                    schemaName = loginService.resourceStrings["SEARCH_ALL_FIELDS"];
                    operation = schemaName + " containing: " + valueString;
                }
                else if (schemaId == "__SEARCH_FTS__") {
                    schemaName = loginService.resourceStrings["FULL_TEXT_SEARCH"] + ": ";
                    operation = schemaName + valueString;
                }

                //parse all the special chars
                if (!isDate && schemaId && schemaId != "__SEARCH_ALL_FIELDS__" && schemaId != "__SEARCH_FTS__") {
                    if (item.valueStr.indexOf('!') == 0 || item.searchOp == enumFactory.searchOperator.NotContains) {
                        var newValue = item.valueStr.indexOf('!') == 0 ? valueString.substring(1, valueString.length) : valueString;
                        operation = schemaName + " " + loginService.resourceStrings["DOES_NOT_CONTAIN"] + ": " + newValue;
                    }
                    else if (item.valueStr.indexOf('*') == 0 || item.searchOp == enumFactory.searchOperator.Contains) {
                        var newValue = item.valueStr.indexOf('*') == 0 ? valueString.substring(1, valueString.length) : valueString;
                        operation = schemaName + " " + loginService.resourceStrings["CONTAINS"] + ": " + newValue;
                    }
                    else if (item.valueStr.indexOf("'") == 0 || item.searchOp == enumFactory.searchOperator.NotEmpty) {
                        operation = schemaName + " " + loginService.resourceStrings["IS_NOT_EMPTY"];
                    }
                    else if (item.valueStr.indexOf("^") == 0 || item.searchOp == enumFactory.searchOperator.NotStarts) {
                        var newValue = item.valueStr.indexOf("'") == 0 ? valueString.substring(1, valueString.length) : valueString;
                        operation = schemaName + " " + loginService.resourceStrings["DOES_NOT_BEGIN_WITH"] + ": " + newValue;
                    }
                    else if (item.valueStr.indexOf("+") == 0 || item.searchOp == enumFactory.searchOperator.NotEmpty) {
                        operation = schemaName + " " + loginService.resourceStrings["IS_NOT_EMPTY"] + ".";
                    }
                    else if (item.valueStr.indexOf("`") == 0 || item.searchOp == enumFactory.searchOperator.Empty) {
                        //if (item.valueStr.length > 1)
                        operation = schemaName + " " + loginService.resourceStrings["IS_EMPTY"] + ".";
                    }
                    else if (item.valueStr.indexOf("=") == 0 || item.searchOp == enumFactory.searchOperator.Equals) {
                        var newValue = item.valueStr.indexOf("=") == 0 ? valueString.substring(1, valueString.length) : valueString;
                        operation = schemaName + " " + loginService.resourceStrings["EXACTLY_MATCHES"] + ": " + newValue;
                    }
                    else if (item.valueStr.indexOf(">") == 0 || item.searchOp == enumFactory.searchOperator.GreaterThan) {
                        var newValue = item.valueStr.indexOf(">") == 0 ? valueString.substring(1, valueString.length) : valueString;
                        operation = schemaName + " " + loginService.resourceStrings["IS_GREATER_THAN_OR_EQUAL_TO"] + ": " + newValue;
                    }
                    else if (item.valueStr.indexOf("<") == 0 || item.searchOp == enumFactory.searchOperator.LessThan) {
                        var newValue = item.valueStr.indexOf("<") == 0 ? valueString.substring(1, valueString.length) : valueString;
                        operation = schemaName + " " + loginService.resourceStrings["IS_LESS_THAN"] + ": " + newValue;
                    }
                    else {

                        //if the field is a logical field
                        if (isLogical) {
                            operation = schemaName + " " + loginService.resourceStrings["S_EQUALS"] + ": " + valueString;
                        }
                        else {
                            if (schemaId != "__SEARCH_FTS__") {
                                //default
                                operation = schemaName + " " + loginService.resourceStrings["STARTS_WITH"] + ": " + valueString;
                            }
                        }

                    }
                }
                else {
                    //if item is a date, values derived from start date, end date and search op
                    switch (item.searchOp) {
                        case enumFactory.searchOperator.OnDate:
                            operation = schemaName + loginService.resourceStrings["ON"] + item.startDate;
                            break;
                        case enumFactory.searchOperator.AfterDate:
                            operation = schemaName + loginService.resourceStrings["AFTER"] + item.startDate;
                            break;
                        case enumFactory.searchOperator.BeforeDate:
                            operation = schemaName + loginService.resourceStrings["BEFORE"]  + item.startDate;
                            break;
                        case enumFactory.searchOperator.DateRange:
                            operation = schemaName + loginService.resourceStrings["AFTER"] + item.startDate + loginService.resourceStrings["AND_BEFORE"] + item.endDate;
                            break;
                        case enumFactory.searchOperator.NotEmpty:
                            operation = schemaName + " " + valueString;
                            break;
                        case enumFactory.searchOperator.Empty:
                            operation = schemaName + " " + valueString;
                            break;
                        default:
                    }
                }
                operations.push(operation);
            });
            return operations;
        }

        service.parseOperationsToString = function(operations) {
            var criteriaString = "";
            if (operations.length == 1) {
                criteriaString = operations[0];
            }
            else {
                angular.forEach(operations, function (item, key) {
                    //last don't add the separator
                    if (key + 1 != operations.length) {
                        criteriaString = criteriaString + item + ' | ';
                    }
                    else {
                        criteriaString = criteriaString + item;
                    }
                });
            }
            return criteriaString;
        }

        service.getCriteriaDisplay = function (searchCriteria) {
            var deferred = $q.defer();
            columnFactory.getAvailableColumns().then(function () {
                var ops = service.parseOperations(searchCriteria);
                var criteria = service.parseOperationsToString(ops);
                deferred.resolve(criteria);
            });          
            return deferred.promise;
        }

        //information for error handler
        service.getData.description = "getData";

        return service;
    }
})();